
































































import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import { DxButton } from "devextreme-vue/ui/button";
import { DxPopup } from "devextreme-vue";
import { DxNumberBox } from 'devextreme-vue/number-box';

import PresetService from '@/services/user_preset_service';

@Component({
  name: "InputSettings",
  components: {
    DxButton,
    DxPopup,
    DxNumberBox,
  }
})
export default class extends Vue {
@PropSync('popupOptions') public localPopupOptions: any;

public fontSize = 1.25;
public tableWidth = 100;
public cardWidth = 100;
public inputValue = 100;
public cardValue = 100;

get cssVars() {
  return {
    '--width':this.tableWidth + 'px'
  }
}

get cssCard() {
  return {
    '--width':this.cardWidth + 'px'
  }
}

mounted() {
}

onShowing() {
  this.inputValue = PresetService.tableWidth;
  this.cardValue = PresetService.cardWidth;
}

wideCard() {
  if (this.cardWidth < 365) {
    this.cardWidth += 5;
    this.cardValue = this.cardWidth;
  }
}

narrowCard() {
  if (this.cardWidth > 50) {
    this.cardWidth -= 5;
    this.cardValue = this.cardWidth;
  }
}

wide() {
  if (this.tableWidth < 365) {
    this.tableWidth += 5;
    this.inputValue = this.tableWidth;
  }
}

narrow() {
  if (this.tableWidth > 50) {
    this.tableWidth -= 5;
    this.inputValue = this.tableWidth;
  }
}

@Watch('cardValue')
getInput() {
  this.cardWidth = Number(this.cardValue);
}

@Watch('inputValue')
getCardInput() {
  this.tableWidth = Number(this.inputValue);
}

onSave() {
  PresetService.tableWidth = this.tableWidth;
  PresetService.cardWidth = this.cardWidth;
  sessionStorage.setItem(`table_width`, `{"user_id": "${localStorage.getItem('user_id')}", "card_width": "${this.cardWidth}", "width": "${this.tableWidth}"}`);
  this.localPopupOptions.visible = false;
}

onClose() {
  this.localPopupOptions.visible = false;
}


}
